import React from "react";
import {TimePicker} from "antd";
import {TimePickerInputBoxProps} from "./interface";
import {SplitInputWrapperProps, InputWrapper} from "../../functions";
import {CONSTANT} from "../../../../config/Constant";
import {validations} from "../../../../config/validations/validations";
import {toLowerCaseWithUnderscore} from "../../../AgGridWrapper/utils/commonFunctions";

const TimePickerInputBox: React.FC<TimePickerInputBoxProps> = (props) => {
    const {
        formProps: {rules = [], ...formProps},
        inputProps: {format = CONSTANT.TIME_FORMAT, ...inputProps},
    } = SplitInputWrapperProps(props);

    if (formProps?.required) {
        rules.filter((rule: any) => rule.required).length === 0 &&
            rules.push(validations.required.other());
    }
    return (
        <InputWrapper
            name={formProps?.label && toLowerCaseWithUnderscore(formProps?.label)}
            rules={rules}
            {...formProps}
        >
            <TimePicker format={format} {...inputProps} />
        </InputWrapper>
    );
};

export default TimePickerInputBox;
